import { OverlayType } from '../constants/common'
import EMA from './ema'

class EMA2 extends EMA {
  static type = OverlayType.Ema2
}

EMA2.prototype.defaults = { color: '#ff6400' }

export default EMA2
